import { default as BaseToggleButtonGroup } from '@mui/joy/ToggleButtonGroup';
import { forwardRef, useMemo } from 'react';
import { ToggleGroupButton, ToggleGroupIconButton } from './components/ToggleGroupButtons';
import type { ToggleButtonGroupProps, ToggleButtonGroupValueType } from './types';
import { getButtonGroupClassName, getRootClassName } from './styles';

const ToggleButtonGroup = forwardRef<
  HTMLDivElement,
  ToggleButtonGroupProps<ToggleButtonGroupValueType>
>(function ToggleButtonGroup<T extends ToggleButtonGroupValueType>(
  props: ToggleButtonGroupProps<T>,
  ref: React.Ref<HTMLDivElement>,
) {
  const { className, disabled, size = 'xs', color = 'neutral', ...rest } = props;

  const buttonGroupClassName = getButtonGroupClassName({
    className,
    size,
  });

  const slotProps = useMemo(() => {
    return {
      root: { className: getRootClassName({ color }) },
    };
  }, [color]);

  return (
    <BaseToggleButtonGroup
      className={buttonGroupClassName}
      disabled={disabled}
      ref={ref}
      // @ts-expect-error -- size is of same type as ButtonGroupSizes. We are not overriding internal types currently
      size={size}
      {...rest}
      slotProps={slotProps}
    />
  );
});

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

const ToggleButtonGroupNamespace = Object.assign(ToggleButtonGroup, {
  Button: ToggleGroupButton,
  IconButton: ToggleGroupIconButton,
});

export default ToggleButtonGroupNamespace;
